// extracted by mini-css-extract-plugin
module.exports = {"inner":"ProfileIcon_inner__2Kj60","head":"ProfileIcon_head__3s1Hg","body":"ProfileIcon_body__2s67X"};